import { DownOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import { capitalize } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './DropdownSelect.module.scss';

const ContactRoles = Object.freeze({
	PRIMARY: "primary",
	Authority: "authority",
	INVOICE: "invoice",
})

const actions = [
	{
		label: "Primary",
		type: ContactRoles.PRIMARY,
		action: "add",
		visible: (currentRoles) => !currentRoles.includes(ContactRoles.PRIMARY)
	},
	{
		label: "Authority",
		type: ContactRoles.Authority,
		action: "add",
		visible: (currentRoles) => !currentRoles.includes(ContactRoles.PRIMARY) && !currentRoles.includes(ContactRoles.Authority)
	},
	{
		label: "Invoice",
		type: ContactRoles.INVOICE,
		action: "add",
		visible: (currentRoles) => !currentRoles.includes(ContactRoles.PRIMARY) && !currentRoles.includes(ContactRoles.INVOICE)
	},
	{
		label: "Remove Authority",
		type: ContactRoles.Authority,
		action: "remove",
		visible: (currentRoles) => currentRoles.includes(ContactRoles.Authority)
	},
	{
		label: "Remove Invoice",
		type: ContactRoles.INVOICE,
		action: "remove",
		visible: (currentRoles) => currentRoles.includes(ContactRoles.INVOICE)
	}
]

const CustomerContactRoleSelect = ({ contactId, isPrimary, isAuthority, isInvoice, onChange }) => {
	const getRoles = () => {
		if (isPrimary) {
			return [ContactRoles.PRIMARY]
		}
		const roles = []
		if (isAuthority) {
			roles.push(ContactRoles.Authority)
		}
		if (isInvoice) {
			roles.push(ContactRoles.INVOICE)
		}
		return roles;
	};

	const getActions = () => actions.filter(action => action.visible(getRoles()))

	const getValue = () => {
		const roles = getRoles()
		if (!roles || roles.length === 0) {
			return 'Set role';
		}
		return roles.map(role => capitalize(role)).join(' / ')
	};

	const onDropdownChange = ({ key }) => {
		if (onChange) {
			const [type, action] = key.split(':')
			onChange({ contactId, type, action })
			return
		}
	};

	if (getActions().length === 0) {
		return <div className={styles.selectedValue}>
			<span className={styles.selectedText}>{getValue()}</span>
		</div>
	}

	return (
		<Dropdown
			menu={{
				items: getActions().map(action => ({
					label: action.label,
					key: [action.type, action.action].join(':')
				})),
				onClick: onDropdownChange
			}}
		>
			<div className={styles.selectedValue}>
				<span className={styles.selectedText}>{getValue()}</span>
				<DownOutlined />
			</div>
		</Dropdown>
	);
};
CustomerContactRoleSelect.propTypes = {
	contactId: PropTypes.number.isRequired,
	isPrimary: PropTypes.bool.isRequired,
	isAuthority: PropTypes.bool.isRequired,
	isInvoice: PropTypes.bool.isRequired,
	onChange: PropTypes.func,
};

export { ContactRoles, CustomerContactRoleSelect };

